import { SortableItemContainerComponent } from "@/Common/Components/Collections/SortableItemContainer";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";

class SortableContainerForActiveMedication extends SortableItemContainerComponent<MedicationModel> { }

export { SortableContainerForActiveMedication };
